// Language selector (i18n.md). The language is resolved server-side (the
// lang user setting > the genus-lang cookie), so switching = persist +
// reload; the server then renders the page in the new language (chrome +
// the g.translate dictionary). Logged-in users get the choice SAVED as
// the `lang` user setting (rides the session context, follows them to
// any device); the cookie is set either way — it covers anonymous
// visitors and the pre-login flow. genus itself never reads the cookie -
// the app owns where the language comes from (a URL prefix on the public
// frontend, this mechanism in the admin).
// Two render sites, one mechanism: .user-menu-lang (the user widget's
// quick settings) and .auth-lang (the auth shell's centered row under
// the card — the pre-login pick that must survive into the session).
export function initLanguage() {
	document.querySelectorAll('.user-menu-lang, .auth-lang').forEach((item) => {
		item.addEventListener('click', async () => {
			const code = item.getAttribute('data-lang');
			if (code === document.documentElement.getAttribute('lang')) return;
			document.cookie = 'genus-lang=' + encodeURIComponent(code) + ';path=/;max-age=31536000;samesite=lax';
			if (window.g && window.g.user && window.g.fetch) {
				// best-effort — the cookie already carries the switch
				try { await window.g.fetch('/frm/user/profile/save', { lang: code }, { progress: false }); } catch (e) { /* offline/anonymous: cookie wins */ }
			}
			location.reload();
		});
	});
}
